<span
  *ngIf="readonly; else ableToEdit"
  [class.readonly]="readonly"
  [attr.aria-label]="label"
>
  <ng-container *ngTemplateOutlet="icon"></ng-container>
</span>

<ng-template #ableToEdit>
  <label class="label" [attr.for]="id" (click)="onClick()">
    <ng-container *ngTemplateOutlet="icon"></ng-container>
    <span class="visually-hidden">{{ label }}</span>
  </label>

  <input
    [id]="id"
    type="radio"
    [name]="name"
    class="visually-hidden"
    [checked]="checked"
    [value]="value"
  />
</ng-template>

<ng-template #icon>
  <span class="icon" [class.icon-empty]="!filled" [class.icon-filled]="filled">
    <svg class="svg-icon">
      <symbol id="{{ starRatingIconName }}-icon" viewBox="0 0 24 24">
        <path
          d="M9.685,9.9 L4,9.9 L3.91220849,9.90708117 C3.49079921,9.97671348 3.33827929,10.5420516 3.70956783,10.8070002 L8.359,14.125 L6.58636975,19.8521171 L6.56717395,19.9380412 C6.50905293,20.3610336 7.00359682,20.6739662 7.36657435,20.3980562 L12,16.876 L16.6417362,20.3982921 L16.7158908,20.4456904 C17.0933796,20.6448681 17.5564257,20.2874778 17.4216302,19.8521171 L15.648,14.124 L20.2907438,10.8067776 L20.3580254,10.7499899 C20.6602824,10.4484166 20.4559448,9.9 20,9.9 L14.314,9.9 L12.4784165,3.85468098 C12.3347707,3.38177301 11.6652293,3.38177301 11.5215835,3.85468098 L9.685,9.9 Z"
        ></path>
      </symbol>
    </svg>

    <i2g-icon
      [icon]="starRatingIcon"
      [style.width.px]="width"
      [style.height.px]="height"
    ></i2g-icon>
  </span>
</ng-template>
